export default __webpack_public_path__ + "static/media/Arrow_blue.ccc24848.svg";